import { request } from '@/api/apiUtils';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { ResponseType, ServerActor } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const ACTORS_ROOT = ['actors'] as const;

// The GLOBAL actors dictionary (backend 2026-09-03): name/surname/age/gender
// records shared across projects, searched by name for the casting quick-fill.
// The casting tab itself never reads this — it stays extras-read-first (see
// characterExtras.ts); this entity exists for dictionary search and to own the
// root the actor mutations invalidate.
const fetchers = {
    search: {
        key: ({ query }: { query: string }) => [...ACTORS_ROOT, 'search', { query }] as const,
        fetch: async ({ query }: { query: string }): Promise<ServerActor[]> => {
            const params = new URLSearchParams();
            if (query) params.set('query', query);
            const response: ResponseType<ServerActor[]> = await request(`actors${params.size ? `?${params}` : ''}`);
            return response.data;
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const actorsEntity: EntityDefinition<typeof fetchers> = {
    name: 'actors',
    roots: [ACTORS_ROOT],
    fetchers,
};
